<script>
  import Scroll from 'base/scroll/scroll'

  export default {
    name: 'DiseaseCompareDetail',
    components: {
      Scroll
    },
    props: {
      compareData: {
        type: Object,
        default() {
          return {
            disease: {},
            comparedDisease: {},
            contrast: 0
          }
        }
      }
    },
    data() {
      return {

      }
    }
  }
</script>

<template>
  <div class="disease-compare-main">
    <!-- <div class="disease-compare-container"
      v-if="compareData && compareData.contrast">
      <div class="contrast">{{ compareData.contrast }}</div>
      <div class="compare-table after-bdr">
        <table>
          <thead>
            <tr>
              <td>
                <template v-if="compareData.disease">{{ compareData.disease.name }}</template>
                <template v-else>—</template>
                <i class="compare">vs</i>
              </td>
              <td>
                <template v-if="compareData.comparedDisease">{{ compareData.comparedDisease.name }}</template>
                <template v-else>—</template>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <template v-if="compareData.disease">{{ compareData.disease.description }}</template>
                <template v-else>—</template>
              </td>
              <td>
                <template v-if="compareData.comparedDisease">{{ compareData.comparedDisease.description }}</template>
                <template v-else>—</template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <scroll
      ref="list"
      class="disease-compare-scroll"
      :listen-scroll="true"
      :pullup="true"
      :data="{'str': compareData}"
    >
      <div class="disease-compare-container">
        <div class="contrast">
          {{ compareData.contrast }}
        </div>
        <div class="compare-table after-bdr">
          <table>
            <thead>
              <tr>
                <td>
                  <template v-if="compareData.disease">
                    {{ compareData.disease.name }}
                  </template>
                  <template v-else>
                    —
                  </template>
                  <i class="compare">vs</i>
                </td>
                <td>
                  <template v-if="compareData.comparedDisease">
                    {{ compareData.comparedDisease.name }}
                  </template>
                  <template v-else>
                    —
                  </template>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <template v-if="compareData.disease">
                    {{ compareData.disease.description }}
                  </template>
                  <template v-else>
                    —
                  </template>
                </td>
                <td>
                  <template v-if="compareData.comparedDisease">
                    {{ compareData.comparedDisease.description }}
                  </template>
                  <template v-else>
                    —
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </scroll>
  </div>
</template>

<style scoped>
  @import 'variable';

  .disease-compare-main {
    height: 100%;
    overflow: hidden;
    .disease-compare-scroll {
      height: 100%;
    }
    .disease-compare-container {
      padding-bottom: 21px;
    }
  }

  .disease-compare-container {
    .contrast {
      padding: 21px 0 15px;
      font-size: 30px;
      color: #508cee;
      line-height: 40px;
      text-align: center;
    }
    .compare-table {
      margin: 0 15px;
      table {
        width: 100%;
        font-size: 13px;
        table-layout: fixed;
        td {
          padding: 15px;
        }
      }
      thead {
        td {
          width: 50%;
          color: #fff;
          text-align: center;
          &:first-child {
            position: relative;
            padding: 15px 17px 15px 15px;
            background-color: #70acf6;
            border-right: 1px solid #fff;
          }
          &:last-child {
            background-color: #ff9900;
          }
        }
      }
      tbody {
        td {
          color: #666;
          line-height: 1.46;
          text-align: justify;
          &:first-child {
            position: relative;
            &:after {
              @apply --bd-w;
              right: -1px;
              top: 0;
              background-color: #e5e5e5;
            }
          }
        }
      }
      .compare {
        z-index: 1;
        position: absolute;
        right: -15px;
        top: 50%;
        width: 30px;
        height: 30px;
        line-height: 26px;
        color: #fff;
        font-size: 20px;
        background-color: #70acf6;
        transform: translateY(-50%);
        border-radius: 100rem;
        border: 1px solid #fff;
        border-radius: 100rem;
      }
    }
  }
</style>